import { render, staticRenderFns } from "./statrgyArticleForm.vue?vue&type=template&id=c97f9468&scoped=true"
import script from "./statrgyArticleForm.vue?vue&type=script&lang=js"
export * from "./statrgyArticleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97f9468",
  null
  
)

export default component.exports